import classnames from 'classnames';
import style from './KolonneInnhold.module.css';

export const KolonneInnhold = ({ children, className, erEgenskap }) => {
  const classes = classnames(style.justerBreddeTilKolonne, className, {
    [style.medBunnMarg]: !erEgenskap,
  });
  return <div className={classes}>{children}</div>;
};
